import type {AtelierActorRuntime,AtelierActorHandle,ScreenContext} from '../../shared';

/** The title shares the actual equipped GLB hero; the retired DNA bust is never used here. */
export function titleHero(ctx:ScreenContext,stage:HTMLElement){
  let runtime:AtelierActorRuntime|null=null;
  let handle:AtelierActorHandle|null=null;
  let disposed=false;
  let loading=true;
  let salutedAt=-1;
  let now=0;
  let bounds={minY:0,maxY:1,radius:.5};
  const ready=(async()=>{
    let pending:AtelierActorRuntime|null=null;
    try{
      if(!ctx.renderer)return;
      const hero=ctx.services.creatures.active();
      const saved=hero?ctx.services.creatures.appearance?.(hero.id):null;
      const recipe=saved?(ctx.services.equipment?.appearance(saved)??saved):await ctx.services.creatures.atelierPreset('tabby-st','wanderer','');
      if(disposed)return;
      pending=await ctx.services.creatures.createAtelierActor(recipe);
      if(disposed)return;
      const uploaded=await ctx.renderer.addAtelierActor(pending.asset);
      if(!uploaded)return;
      if(disposed){uploaded.dispose();return;}
      handle=uploaded;runtime=pending;pending=null;
      bounds=runtime.sample(0,{action:'idle',reducedMotion:true,yaw:.12}).bounds;
      ctx.renderer.setScene({kind:'stage',backdrop:'vault'});
      stage.replaceChildren();stage.dataset.renderer='atelier';
    }catch{stage.dataset.renderer='painted';}
    finally{pending?.dispose();loading=false;stage.removeAttribute('aria-busy');}
  })();
  return {ready,
    salute(){salutedAt=now;},
    render(ms:number){
      now=ms;
      if(!runtime||!handle||!ctx.renderer||disposed)return;
      const rect=stage.getBoundingClientRect();if(!rect.width||!rect.height)return;
      const reduced=/^(min|reduced)$/.test(document.documentElement.dataset.motion??'');
      const elapsed=(ms-salutedAt)/1000;
      const greet=!reduced&&salutedAt>=0&&elapsed<1.5;
      handle.setFrame(runtime.sample(reduced?0:ms/1000,{action:greet?'greet':'idle',actionTime:greet?elapsed:ms/1000,reducedMotion:reduced,yaw:.12}));
      const center=(bounds.minY+bounds.maxY)/2;
      ctx.renderer.panel.set({rect:{x:rect.x,y:rect.y,w:rect.width,h:rect.height},frame:'pointedArch',archK:.2});
      ctx.renderer.camera.set({eye:[0,center+.9,6],target:[0,center,0],fovYDeg:22,dutchDeg:0,orthoHalfH:Math.max((bounds.maxY-bounds.minY)*.57,bounds.radius*rect.height/rect.width+.06),near:.1,far:30});
      ctx.renderer.advanceTo({presentMs:ms,worldMs:ms,vfxMs:ms});
    },
    debugState:()=>({loading,renderer:stage.dataset.renderer,model:runtime?.appearance.model}),
    dispose(){disposed=true;handle?.dispose();runtime?.dispose();ctx.renderer?.camera.set(null);}
  };
}
